var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('imageloader',{attrs:{"scr":"empty.gif","srcset":_vm.srcset(_vm.file),"sizes":_vm.sizes}})}
var staticRenderFns = []

export { render, staticRenderFns }